<ng-template #loading>
  <app-ns-spinner></app-ns-spinner>
</ng-template>

<ng-container *ngIf="phone$ | async as phone; else loading">
  <div class="p-d-flex p-flex-column p-ai-center p-jc-between phone">
    <p-inputMask
      placeholder="+7"
      mask="+7 999 999 99 99"
      [ngModel]="phone">
    </p-inputMask>
    <button (click)="close()">Закрыть</button>
  </div>
</ng-container>
